import axios, { AxiosError } from 'axios';
import { getHeaders } from './utils/getHeader';
import { TImage } from '../types';

type ReportProblemPayload = {
  body: string;
  files: TImage[];
};

type ReportProblemResult = {
  data?: { success: boolean };
  error?: any;
};

type SendPartnerEmailPayload = {
  name: string;
  surname: string;
  email: string;
  phone: string;
  message: string;
};

type SendPartnerEmailResult = {
  data?: { success: boolean };
  error?: any;
};

export const reportProblem = async (data: ReportProblemPayload) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/contacts`;

  let result: ReportProblemResult = {};

  const formData = new FormData();
  formData.append('body', data.body);

  data.files?.forEach((f) => {
    formData.append('files', f.file as Blob);
  });

  try {
    const response = await axios.post(url, formData, {
      headers: getHeaders(true),
    });

    result.data = response.data as { success: boolean };
  } catch (error) {
    const { response } = error as AxiosError;
    console.error('Error calling: ', url);
    result.error = response?.data;
  }

  return result;
};

export const sendPartnerEmail = async (
  data: SendPartnerEmailPayload
): Promise<SendPartnerEmailResult> => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/contacts/partner`;

  let result: SendPartnerEmailResult = {};

  try {
    const response = await axios.post(url, data, {
      headers: getHeaders(true),
    });
    result.data = response.data as { success: boolean };
  } catch (error: any) {
    const { response } = error as AxiosError;
    console.error('Error calling: ', url);
    result.error = { message: response?.data, statusCode: response?.status };
  }

  return result;
};

export const contactUsEmail = async (
  data: SendPartnerEmailPayload
): Promise<SendPartnerEmailResult> => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/contacts/contact-us`;

  let result: SendPartnerEmailResult = {};

  try {
    const response = await axios.post(url, data, {
      headers: getHeaders(true),
    });
    result.data = response.data as { success: boolean };
  } catch (error: any) {
    const { response } = error as AxiosError;
    console.error('Error calling: ', url);
    result.error = { message: response?.data, statusCode: response?.status };
  }

  return result;
};